<template>
     <div>
          <v-app-bar
               id="home-app-bar"
               app
               color="white"
               elevation="1"
               height="80"
          >
               <base-img
                    :src="require('@/assets/images/placeholder.gif')"
                    class="mr-3 hidden-xs-only"
                    contain
                    max-width="52"
                    width="100%"
               />

               <base-img
                    :src="require('@/assets/images/placeholder.gif')"
                    contain
                    max-width="128"
                    width="100%"
               />

               <v-spacer />

               <div>
                    <ul
                         id="menuNav"
                         style="list-style-type: none"
                         class="hidden-sm-and-down"
                    >
                         <li
                              v-bind:key="index"
                              v-for="(menuItem, index) in menuItems"
                              style="list-style-type: none; display: inline"
                         >
                              <template v-if="menuItem.subPages">
                                   <v-menu :offset-y="true">
                                        <template
                                             v-slot:activator="{ on, attrs }"
                                        >
                                             <v-btn
                                                  color="primary"
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  text
                                             >
                                                  {{ menuItem.name }}
                                             </v-btn>
                                        </template>
                                        <v-list dense style="padding: 0px">
                                             <v-list-item
                                                  v-for="(item,
                                                  index) in menuItem.subPages"
                                                  :key="index"
                                                  :to="item.route"
                                             >
                                                  <v-list-item-title>{{
                                                       item.name
                                                  }}</v-list-item-title>
                                             </v-list-item>
                                        </v-list>
                                   </v-menu>
                              </template>
                              <template v-if="!menuItem.subPages">
                                   <v-btn
                                        color="primary"
                                        text
                                        :to="menuItem.route"
                                   >
                                        {{ menuItem.name }}
                                   </v-btn>
                              </template>
                         </li>
                    </ul>
               </div>

               <v-app-bar-nav-icon
                    class="hidden-md-and-up"
                    @click="drawer = !drawer"
               />
          </v-app-bar>

          <home-drawer v-model="drawer" :items="menuItems" />
     </div>
</template>

<script>
export default {
     name: 'HomeAppBar',

     components: {
          HomeDrawer: () => import('./Drawer'),
     },

     data: () => ({
          drawer: null,
          menuItems: [
               {
                    name: 'Home Pages',
                    route: '',
                    subPages: [{ name: 'Home (Video)', route: '/' }],
               },
          ],
     }),
}
</script>

<style lang="sass">
#home-app-bar
.v-tabs-slider
     max-width: 24px
     margin: 0 auto

     .v-tab
     &::before
          display: none
</style>
